import { AxiosResponse, AxiosError } from "axios";

import { RESERVE_API_ENDPOINTS } from "@/features/reserves/api/endpointsReserve";
import { ReserveBaseModel } from "@/features/reserves/types/reserveModels";
import apiRequests from "@/shared/config/axiosConfig";

export default async function getReserves(
  projectId: string
): Promise<ReserveBaseModel[]> {
  try {
    const url = RESERVE_API_ENDPOINTS.GET_RESERVES.replace("{projectId}", projectId);
    const response: AxiosResponse<ReserveBaseModel[]> = await apiRequests.get(url);

    if (response.status === 200) {
      const reserves: ReserveBaseModel[] = response.data;
      return reserves;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
